import HandymanTasks from "../../components/handyman/tasks/tasks";

const TasksPage = () => {
  return <HandymanTasks />;
};

export default TasksPage;
